import { Link } from 'react-router-dom';

export const PublicFooter = ({ className = '' }) => {
  return (
    <footer className={`border-t border-border mt-12 py-8 ${className}`}>
      <div className="max-w-4xl mx-auto px-6">
        <div className="flex flex-col sm:flex-row sm:justify-between gap-6 text-sm text-muted-foreground">
          {/* Address */}
          <div className="leading-relaxed" data-testid="footer-address">
            <p className="font-bold text-foreground">S.H.R.T.</p>
            <p>Swiss Historic Racing Team</p>
            <p className="text-xs">Verein gem&auml;ss Art. 60 ff. ZGB</p>
            <p className="mt-2">Kuno Sch&auml;r</p>
            <p>St. Niklausstrasse 1</p>
            <p>CH-4502 Solothurn</p>
            <p className="mt-2">
              Tel.{' '}
              <a href="tel:+41794153031" className="hover:text-foreground">+41 79 415 30 31</a>
            </p>
            <p>
              E-Mail:{' '}
              <a href="mailto:info@kunoschaer.ch" className="hover:text-foreground">info@kunoschaer.ch</a>
            </p>
            <p className="mt-2 pt-2 border-t border-border">
              Technische Anliegen: Thomas Barth{' · '}
              <a href="mailto:barththomas@mac.com" className="hover:text-foreground">barththomas@mac.com</a>
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col gap-1 text-right" data-testid="footer-links">
            <Link to="/datenschutz" className="hover:text-foreground">Datenschutz</Link>
            <Link to="/agb" className="hover:text-foreground">AGB</Link>
            <Link to="/impressum" className="hover:text-foreground">Impressum</Link>
            <Link to="/support" className="hover:text-foreground">Support</Link>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-border text-center text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()} Swiss Historic Racing Team
        </div>
      </div>
    </footer>
  );
};
